module.exports = __webpack_public_path__ + "img/ai8@2x.e383d938.png";